import { Component, Input } from '@angular/core';

import { HttpErrorResponse } from '@angular/common/http';
import { extractMessage } from '../../utils/error.util';

@Component({
    selector: 'app-error-message',
    imports: [],
    templateUrl: './error-message.component.html'
})
export class ErrorMessageComponent {
  @Input() header = 'Error';

  errorMessage: string | null = null;

  @Input() set error(err: HttpErrorResponse | null) {
    this.errorMessage = err ? extractMessage(err) : null;
  }
}
